/**
 * Helper function used by {@link loadComponent} to merge settings overriden in HTML data attributes with the internal defaults.
 *
 * @module settings
 * @category utils
 * @see module:loadComponents
 */

const settingsPropertyRegex = /([\w\-$]+):[\s\d\{\[\'\"\-ftun]/gi // ftun == false/true/undefined/null
const settingsQuoteRegex = /'/g

export default {
    set: (settings, opts) => {
        // if we don't have any settings, return the defaults
        if (!opts) return settings

        if (opts[0] !== '{') {  // is using JSON syntax
            const jsonString = opts
                .replace(settingsPropertyRegex, '\"$1\":') // wrap all property names with quotes
                .replace(settingsQuoteRegex, '\"'); // replace single-quote character with double quotes

            opts = `{${jsonString}}`
        }

        opts = JSON.parse(opts)

        return Object.assign(settings, opts)
    }
}
